// src/utils/upgradeSuperAdmin.js
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

/**
 * Upgrade current user to super_admin role for multi-tenant management
 */
export const upgradeSuperAdmin = async (userId) => {
  if (!userId || !db) {
    throw new Error('User ID or Firebase not available');
  }

  try {
    console.log('🔧 Upgrading user to super_admin role...');
    
    await updateDoc(doc(db, 'users', userId), {
      role: 'super_admin',
      permissions: [
        'manage_users',
        'manage_clients', 
        'manage_appointments',
        'manage_invoices',
        'manage_settings',
        'manage_tenants',
        'switch_tenants',
        'view_reports',
        'super_admin_access'
      ],
      updatedAt: new Date().toISOString()
    });

    console.log('✅ Successfully upgraded to super_admin');
    return { success: true };

  } catch (error) {
    console.error('❌ Failed to upgrade to super_admin:', error);
    throw error;
  }
};

// Make it available in browser console
if (typeof window !== 'undefined') {
  window.upgradeSuperAdmin = upgradeSuperAdmin;
}
